var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ModuleValueGeneral, SchemaModuleGeneral } from './module-general';
import * as rawJSONSchemaModuleCancerUterine from '../../schemas/module-cancer-uterine.json';
var ModuleValueCancerUterine = (function (_super) {
    __extends(ModuleValueCancerUterine, _super);
    function ModuleValueCancerUterine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModuleValueCancerUterine;
}(ModuleValueGeneral));
var SchemaModuleCancerUterine = (function (_super) {
    __extends(SchemaModuleCancerUterine, _super);
    function SchemaModuleCancerUterine() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModuleCancerUterine);
        return _this;
    }
    SchemaModuleCancerUterine.prototype.hook = function (form) {
        _super.prototype.hook.call(this, form);
        this.listenValue(['myometrial_invasion_depth_surgery', 'myomterial_thickness_surgery'], this.fieldHandlerCalculateMyometrialInvasion.bind(this));
        var cellStageFieldsSurgery = ['stage_endometrial_surgery', 'stage_adenosarcoma_surgery', 'stage_mesenchymal_surgery'];
        var cellStageFieldsChemotherapy = ['stage_endometrial_chemotherapy', 'stage_adenosarcoma_chemotherapy', 'stage_mesenchymal_chemotherapy'];
        var cellStageFieldsRadiotherapy = ['stage_endometrial_radiotherapy', 'stage_adenosarcoma_radiotherapy', 'stage_mesenchymal_radiotherapy'];
        var cellStageFieldsHormonal = ['stage_endometrial_hormonal', 'stage_adenosarcoma_hormonal', 'stage_mesenchymal_hormonal'];
        this.listenValue(cellStageFieldsSurgery, this.fieldHandlerCalculateCellStage('stage_calc_surgery').bind(this));
        this.listenValue(cellStageFieldsChemotherapy, this.fieldHandlerCalculateCellStage('stage_calc_chemotherapy').bind(this));
        this.listenValue(cellStageFieldsRadiotherapy, this.fieldHandlerCalculateCellStage('stage_calc_radiotherapy').bind(this));
        this.listenValue(cellStageFieldsHormonal, this.fieldHandlerCalculateCellStage('stage_calc_hormonal').bind(this));
        this.listenValue('follow_up_duration_compute', this.fieldHandlerFollowUpDurationCompute.bind(this));
        this.listenValue(['date_last_follow_up', 'date_treatment_started'], this.fieldHandlerCalculateFollowUpDuration.bind(this));
    };
    SchemaModuleCancerUterine.prototype.fieldHandlerCalculateFollowUpDuration = function (followUpDate, startDate) {
        if (!this.getValue('follow_up_duration_compute'))
            return;
        this.updateValue('follow_up_duration', this.diffInMonths(followUpDate, startDate, 30.5));
    };
    SchemaModuleCancerUterine.prototype.fieldHandlerFollowUpDurationCompute = function (compute) {
        if (typeof compute === 'undefined' || compute === null)
            return;
        this.schema.properties['follow_up_duration'].readOnly = compute;
        if (compute) {
            this.fieldHandlerCalculateFollowUpDuration(this.getValue('date_last_follow_up'), this.getValue('date_treatment_started'));
        }
    };
    SchemaModuleCancerUterine.prototype.setupValidators = function () {
        _super.prototype.setupValidators.call(this);
        this.validatorDateComparison('date_of_birth', 'date_of_diagnosis', '<');
        this.validatorDateComparison('date_of_diagnosis', 'date_last_follow_up', '<');
        this.validatorValueComparison('myometrial_invasion_depth_surgery', 'myomterial_thickness_surgery', '<=');
        this.validatorDate('date_of_birth', (new Date()), '<=', function (v) { return new Date(v); });
        this.validatorDate('date_of_diagnosis', (new Date()), '<=', function (v) { return new Date(v); });
    };
    SchemaModuleCancerUterine.prototype.fieldHandlerCalculateMyometrialInvasion = function (depth, thickness) {
        var percent = null;
        if (depth !== null && thickness !== null && !isNaN(depth) && !isNaN(thickness) && thickness !== 0) {
            percent = Math.floor((depth / thickness) * 100);
        }
        if (isNaN(percent)) {
            percent = null;
        }
        this.updateValue('myometrial_invasion_percent_surgery', percent);
    };
    SchemaModuleCancerUterine.prototype.fieldHandlerCalculateCellStage = function (propertyNameCellStage) {
        var _this = this;
        return function (endometrial, adenosarcoma, mesenchymal) {
            var maxStage = (endometrial || []).concat((adenosarcoma || []), (mesenchymal || [])).map(function (v) { return (v.match(/^stage_.+?(?=_)/) || [null])[0]; })
                .filter(function (v) { return !!v; })
                .sort()
                .pop() || null;
            _this.updateValue(propertyNameCellStage, maxStage);
        };
    };
    return SchemaModuleCancerUterine;
}(SchemaModuleGeneral));
export { SchemaModuleCancerUterine };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-cancer-uterine.ts.pre-build-optimizer.js